import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const boilingPointCalculatorTool: Tool = {
  id: "boiling-point-calculator",
  name: () => m.bp_tool_name(),
  description: () => m.bp_tool_description(),
  icon: "🌡️",
  basePath: "/boiling-point-calculator",
  status: "stable",
  tags: [
    "science",
    "chemistry",
    "distillation",
    "vacuum",
    "antoine",
    "boiling-point-calculator",
  ],
};
